// extracted by mini-css-extract-plugin
export default {"flow-heading":"FlowsHeader_flow-heading__mMbAr","flows-header":"FlowsHeader_flows-header__H9FJC","flows-header-home-page":"FlowsHeader_flows-header-home-page__nh7Gq"};